<div class="row" role="main">
  <div class="col-md-12 col-sm-12 table-responsive no-border">
    <form [formGroup]="deviceForm" novalidate>
      <ng-container *ngIf="isAustraliaChannel">
        <table class="table table-condensed">
          <tbody>
            <tr>
              <td class="col-sm-12 no-left-padding no-right-padding">
                <table class="table table-inner table-condensed table-striped">
                  <tbody>
                    <tr>
                      <th role="columnheader" aria-label="DI Record Publish Date" class="col-sm-12">DI Record Publish Date</th>
                    </tr>
                    <tr>
                      <td role="gridcell" aria-label="cell of DI Record Publish Date">
                        <label controlName="diRecordPublishDate"></label>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </td>
            </tr>

            <tr>
              <td class="col-sm-12 no-left-padding no-right-padding">
                <table class="table table-inner table-condensed table-striped">
                  <tbody>
                    <tr>
                      <th role="columnheader" aria-label="Data Supplier Role" class="col-sm-6">Data Supplier Role</th>
                      <th role="columnheader" aria-label="Data Supplier ID" class="col-sm-6">Data Supplier ID</th>
                    </tr>
                    <tr>
                      <td role="gridcell" aria-label="cell of Data Supplier Role">
                        <label controlName="dataSupplierRole"></label>
                      </td>
                      <td role="gridcell" aria-label="cell of Data Supplier ID">
                        <label controlName="dataSupplierId"></label>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </td>
            </tr>

            <tr>
              <td class="col-sm-12 no-left-padding no-right-padding">
                <table class="table table-inner table-condensed table-striped">
                  <tbody>
                    <tr>
                      <th role="columnheader" aria-label="Is the device associated with multiple sponsors?" class="col-sm-12">Is the device associated with multiple sponsors?</th>
                    </tr>
                    <tr>
                      <td role="gridcell" aria-label="cell of Is the device associated with multiple sponsors?">
                        <label controlName="multipleSponsorsIndicator"></label>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </td>
            </tr>

            <tr>
              <td class="col-sm-12 no-left-padding no-right-padding">
                <table class="table table-inner table-condensed table-striped">
                  <tbody>
                    <tr>
                      <th role="columnheader" aria-label="Manufacturer ID" class="col-sm-6">Manufacturer ID</th>
                      <th role="columnheader" aria-label="Manufacturer Name" class="col-sm-6">Manufacturer Name</th>
                    </tr>
                    <tr>
                      <td role="gridcell" aria-label="cell of Manufacturer ID">
                        <label controlName="manufacturerId"></label>
                      </td>
                      <td role="gridcell" aria-label="cell of Manufacturer Name">
                        <label controlName="manufacturerName"></label>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </td>
            </tr>
          </tbody>
        </table>
      </ng-container>
      <ng-container *ngIf="!isAustraliaChannel">
        <table class="table table-condensed"
          *ngIf="dataScope.toLowerCase() !== dataScopeEnum.US.toLowerCase() && dataScope.toLowerCase() !== dataScopeEnum.AU.toLowerCase() && dataScope.toLowerCase() !== dataScopeEnum.BRAZIL.toLowerCase()">
          <tbody>
            <tr *ngIf="dataScope.toLowerCase() !== dataScopeEnum.SKOREA.toLowerCase()">
              <td class="col-sm-6 no-left-padding no-right-padding">
                <table class="table table-inner table-condensed table-striped">
                  <tbody>
                    <tr>
                      <th role="columnheader" aria-label="DI Record Publish Date" class="col-sm-6">DI Record Publish Date
                      </th>
                    </tr>
                    <tr>
                      <td role="gridcell" aria-label="cell of DI Record Publish Date"><label
                          controlName="diRecordPublishDate"></label></td>
                    </tr>
                  </tbody>
                </table>
              </td>

              <td class="col-sm-6 no-right-padding no-left-padding">
                <table class="table table-inner table-condensed table-striped">
                  <tbody>
                    <tr>
                      <th role="columnheader" aria-label="Change Description" class="col-sm-6">Change Description</th>
                    </tr>
                    <tr>
                      <td role="gridcell" aria-label="cell of Change Description"><label
                          controlName="changeDescription"></label></td>
                    </tr>
                  </tbody>
                </table>
              </td>
            </tr>

            <tr *ngIf="dataScope.toLowerCase() !== dataScopeEnum.SKOREA.toLowerCase()">
              <td class="col-sm-6 no-left-padding no-right-padding">
                <table class="table table-inner table-condensed table-striped">
                  <tbody>
                    <tr>
                      <th role="columnheader" aria-label="Is Primary DI same as the Registered or Filed DI?"
                        class="col-sm-7">Is Primary DI same as the Registered or Filed DI?</th>
                      <th role="columnheader" aria-label="Registered or Filed DI" class="col-sm-5">Registered or Filed DI
                      </th>
                    </tr>
                    <tr>
                      <td role="gridcell" aria-label="cell of Is Primary DI same as the Registered or Filed DI?"><label
                          controlName="isPrimaryDiSameAsRegisteredOrFiledDi"></label></td>
                      <td role="gridcell" aria-label="cell of Registered or Filed DI"><label
                          controlName="registeredOrFiledDi"></label></td>
                    </tr>
                  </tbody>
                </table>
              </td>

              <td class="col-sm-6 no-left-padding no-right-padding">
                <table class="table table-inner table-condensed table-striped">
                  <tbody>
                    <tr>
                      <th role="columnheader" aria-label="Unified Social Credit Code" class="col-sm-6">Unified Social
                        Credit Code</th>
                    </tr>
                    <tr>
                      <td role="gridcell" aria-label="cell of Unified Social Credit Code"><label
                          controlName="unifiedSocialCreditCode"></label></td>
                    </tr>
                  </tbody>
                </table>
              </td>
            </tr>

            <tr *ngIf="dataScope.toLowerCase() !== dataScopeEnum.SKOREA.toLowerCase()">
              <td class="col-sm-6 no-left-padding no-right-padding">
                <table class="table table-inner table-condensed table-striped">
                  <tbody>
                    <tr>
                      <th role="columnheader" aria-label="Device Registrant or Filer Name" class="col-sm-6">Device
                        Registrant or Filer Name</th>
                      <th role="columnheader" aria-label="Device Registrant or Filer Name in English" class="col-sm-6">
                        Device Registrant or Filer Name in English</th>
                    </tr>
                    <tr>
                      <td role="gridcell" aria-label="cell of Device Registrant or Filer Name"><label
                          controlName="deviceRegistrantOrFilerName"></label></td>
                      <td role="gridcell" aria-label="cell of Device Registrant or Filer Name in English"><label
                          controlName="deviceRegistrantOrFilerNameInEnglish"></label></td>
                    </tr>
                  </tbody>
                </table>
              </td>

              <td class="col-sm-6 no-left-padding no-right-padding">
                <table formArrayName="registrationOrFilingCertificateNumbersForm"
                  class="table table-inner table-condensed table-striped">
                  <tbody>
                    <tr>
                      <th role="columnheader" aria-label="Registration Certificate Number or Filing Certificate Number"
                        class="col-sm-6">Registration Certificate Number or Filing Certificate Number</th>
                    </tr>
                    <ng-container *ngIf="registrationOrFilingCertificateNumbersForm?.controls?.length; else emptyTemplate1fields">
                    <tr formGroupName="{{i}}"
                      *ngFor="let regFil of registrationOrFilingCertificateNumbersForm.controls; let i = index">
                      <td role="gridcell"
                        aria-label="cell of Registration Certificate Number or Filing Certificate Number">
                        <label controlName="regFilNumber"></label>
                      </td>
                    </tr>
                    </ng-container>
                  </tbody>
                </table>
              </td>
            </tr>

            <tr *ngIf="dataScope.toLowerCase() !== dataScopeEnum.CHINA.toLowerCase()">
              <td class="col-sm-6 no-left-padding no-right-padding">
                <table class="table table-inner table-condensed table-striped">
                  <tbody>
                    <tr>
                      <th role="columnheader" aria-label="Medical Device Information Manager Phone Number"
                        class="col-sm-7">Medical Device Information Manager Phone Number</th>
                    </tr>
                    <tr>
                      <td role="gridcell" aria-label="cell of Medical Device Information Manager Phone Number"><label
                          controlName="medicalDeviceInfoManagerPhone"></label></td>
                    </tr>
                  </tbody>
                </table>
              </td>

              <td class="col-sm-6 no-left-padding no-right-padding">
                <table class="table table-inner table-condensed table-striped">
                  <tbody>
                    <tr>
                      <th role="columnheader" aria-label="Medical Device Information Manager Email" class="col-sm-6">
                        Medical Device Information Manager Email</th>
                    </tr>
                    <tr>
                      <td role="gridcell" aria-label="cell of Medical Device Information Manager Email"><label
                          controlName="medicalDeviceInfoManagerEmail"></label></td>
                    </tr>
                  </tbody>
                </table>
              </td>
            </tr>
            <feature [name]="'sk-device-license-number'">
            <tr>
              <ng-container>
                <td class="col-sm-6 no-left-padding no-right-padding">
                  <table class="table table-inner table-condensed table-striped">
                    <tbody>
                      <tr>
                        <th class="col-sm-6">Device License Number</th>
                      </tr>
                      <tr>
                        <td [ngClass]="isDefault('Device License Number')">
                          <label controlName="deviceLicenseNumber"></label>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </td>
                </ng-container>
            </tr>
          </feature>
          </tbody>
        </table>
        <table class="table table-condensed"
          *ngIf="dataScope.toLowerCase() === dataScopeEnum.US.toLowerCase() || dataScope.toLowerCase() === dataScopeEnum.BRAZIL.toLowerCase()">
          <tbody>
            <tr *ngIf="dataScope.toLowerCase() !== dataScopeEnum.SKOREA.toLowerCase()">
              <td class="col-sm-12 no-left-padding no-right-padding">
                <table class="table table-inner table-condensed table-striped">
                  <tbody>
                    <tr>
                      <th role="columnheader" aria-label="DI Record Publish Date">DI Record Publish Date</th>
                    </tr>
                    <tr>
                      <td role="gridcell" aria-label="cell of DI Record Publish Date"><label
                          controlName="diRecordPublishDate"></label></td>
                    </tr>
                  </tbody>
                </table>
              </td>
            </tr>
          </tbody>
        </table>
      </ng-container>
    </form>
  </div>
</div>
<ng-template #emptyTemplate1fields>
  <tr>
    <td role="gridcell"><label></label></td>
  </tr>
</ng-template>
